export { default, TabProps } from '@material-ui/core/Tab';
